import React, { Component } from "react"
import PropTypes from "prop-types"
import isEqual from "lodash/isEqual"
import {
  Editor,
  LayoutState,
  Row1,
  Row2,
  Row3,
  Row4,
  Row5,
  Row6,
  Row7,
  Body,
  Content,
  ContentCarousel,
  CarouselView,
  CarouselAnimationView,
  TextView,
  ImageView,
  ImageTextView,
  AvatarView,
  DividerView,
  FlatButtonView,
  IconButtonView,
  FAButtonView,
  ProductListView,
  DealGroupView,
  YoutubeView,
  PropsPlugin,
} from "../editor/layout"
import DnD from "../editor/layout/addons/dnd"
import Select from "../editor/layout/addons/select"

const comps = {
  Row1,
  Row2,
  Row3,
  Row4,
  Row5,
  Row6,
  Row7,
  Body,
  Content,
  ContentCarousel,
  TextView,
  ImageView,
  ImageTextView,
  AvatarView,
  DividerView,
  CarouselView,
  CarouselAnimationView,
  FlatButtonView,
  IconButtonView,
  FAButtonView,
  ProductListView,
  YoutubeView,
  DealGroupView,
}

class EditorLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      layoutState: props.data
        ? LayoutState.fromRaw(props.data)
        : new LayoutState(),
      dataEditor: props.data,
    }
  }

  componentWillReceiveProps(nextProps) {
    let { data } = nextProps
    if (!isEqual(data, this.state.dataEditor) && data) {
      if (data.root) {
        this.setState({
          layoutState: LayoutState.fromRaw(data),
          dataEditor: data,
        })
      } else {
        this.setState({
          layoutState: data,
          dataEditor: data,
        })
      }
    }
  }
  onResetPage = () => {
    this.setState({
      layoutState: new LayoutState(),
    })
  }
  handleLayoutChange = (layout) => {
    // console.log(layout);
    // console.log(this.state.layoutState);
    let newLayout = layout.toRaw()
    // this.setState({ layoutState: layout });
    this.props.onChangeData(layout, newLayout)
  }

  render() {
    const { statusForm, isShow, typePage, marketerId } = this.props
    return (
      <div style={{ position: "relative", height: "100%" }}>
        <Editor
          statusForm={statusForm}
          layoutState={this.state.layoutState}
          onChange={this.handleLayoutChange.bind(this)}
          addons={[PropsPlugin, DnD, Select]}
          components={comps}
          isShow={isShow}
          typePage={typePage}
          marketerId={marketerId}
        />
      </div>
    )
  }
}

EditorLayout.propTypes = {
  data: PropTypes.object,
  onChangeData: PropTypes.func,
  isShow: PropTypes.bool,
  statusForm: PropTypes.string,
  typePage: PropTypes.string,
  marketerId: PropTypes.string,
}

EditorLayout.defaultProps = {
  isShow: true,
  statusForm: "edit",
  typePage: "",
  marketerId: "0",
}

export default EditorLayout



// WEBPACK FOOTER //
// ./src/contents/EditorLayout.js